module.exports = __webpack_public_path__ + "static/media/notification.9bc32ac0.svg";